export default {
  // AboutPage - 私たちについてページ
  aboutUs: '私たちについて',
  aboutUsSubtitle: '旅から生まれたストーリー、大切な家族のために作られたシステム',

  ourStory: '私たちのストーリー',
  howItAllBegan: 'すべては、一つの旅から始まった',
  storyParagraph1: '出発前夜、私たちはテーブルに座り、びっしりと書き込まれた紙を前に途方に暮れていました。食事の時間、量、おやつの制限、毎日の薬、かかりつけの獣医の番号、緊急連絡先……ペットシッターに伝えなければならないことは、想像をはるかに超えていました。すべてを書き留めても、どこか不安が残りました――これだけの情報を、本当に全部覚えてもらえるのだろうか、と。',
  storyParagraph2: '旅の途中、次々とメッセージが届きました。「ご飯は何粒あげればいい？」「あのお薬は朝？夜？」「ご飯を食べないんだけど、大丈夫？」通知のたびにスマホが手放せなくなりましたが、時差や予定の詰まったスケジュールのせいで、すぐに返信できないこともしばしばでした。心配で旅を楽しめない自分がいて、何度も聞かなければならない状況にプレッシャーを感じているペットシッターもいました。',
  storyParagraph3: 'そのとき、一つのアイデアが生まれました――ペットに関するすべての情報が整理されていて、誰でもいつでも確認できる場所があったら。推測も、繰り返しの質問也、情報を間違える心配も、すべてなくなるはずです。こうして、このプラットフォームが誕生しました。一匹ひとりのペットに合わせてカスタマイズされ、情報は常に100%正確。リンク一つで共有できます。旅行中でも、一時的にペットを預けるときでも、本当の意味で安心して出かけられる――大切な家族が、最善のケアを受けられると信じて。',

  storyHighlight1: '旅行前に手書きのメモを用意する必要がなくなる',
  storyHighlight2: 'ペットシッターがいつでも確認でき、繰り返しの質問が減る',
  storyHighlight3: '情報は100%正確 — オーナーも安心、ペットも最善のケアを受けられる',
  storyImageCaption1: 'どんな旅も、安心して出発できる',
  storyImageCaption2: 'あの子は家で待っている。あなたは安心して旅できる',

  founded: '設立',
  uniqueStatValue: '唯一無二',
  uniqueStat: '一匹ずつ専用プロフィール',
  alwaysThereValue: '24/7',
  alwaysThere: 'いつでもそこにある、あの子の情報',

  ourMission: '私たちの使命',
  whyWeExist: '私たちが存在する理由',
  missionStatement: '革新的な技術を通じてペットケアをよりシンプルで正確にし、すべてのペットオーナーと介護者が最高品質のケアを提供できるよう支援し、すべてのペットが幸せで安全な生活を楽しめるようにすることに専念しています。',
  betterCare: '優れたケア',
  betterCareDesc: 'ペットオーナーが最もプロフェッショナルで思いやりのあるケアを提供できるよう支援',
  peaceMind: '安心',
  peaceMindDesc: 'ペットの健康とケア状況をいつでも把握',
  buildCommunity: 'コミュニティの構築',
  buildCommunityDesc: 'ペット愛好家とプロの介護者をつなぐ',

  ourValues: '私たちの価値観',
  whatDrivesUs: '私たちを駆り立てる核心原則',
  valuesDescription: 'これらの核となる価値観が、私たちのすべての決定と行動を導いています。',
  excellence: '卓越性の追求',
  excellenceDesc: 'サービス品質を継続的に向上させ、最高のユーザー体験を提供',
  innovation: '革新を受け入れる',
  innovationDesc: '革新的な思考を受け入れ、より良いソリューションを見つける',
  reliability: '信頼できる',
  reliabilityDesc: '安心して信頼できる信頼性の高いサービスを提供',

  joinOurMission: '私たちの使命に参加',
  joinMissionDescription: '私たちのコミュニティの一部になり、一緒にペットケアのより良い未來を創造しましょう。',
  getStarted: '始める',

  // ContactPage
  contactUs: 'お問い合わせ',
  contactUsSubtitle: '質問や提案がありますか？お聞かせください。',
  technicalSupport: '技術サポート',
  homyTechLimited: 'Homy Tech Limited',
  homyTechDescription: '私たちはペットテクノロジーに特化した革新的な企業で、ペットオーナーとケアギバーに最も思いやりのある専門的なデジタルソリューションを提供することに専念しています。',
  contactByEmail: 'メールでお問い合わせ',
  clickToSendEmail: 'クリックしてメールを送信すると、できるだけ早くご返信いたします',
  responseTime: '心を込めた返信',
  responseTimeDesc: 'すべてのメッセージを丁寧に読み、合理的な時間内に返信できるよう最善を尽くします',
  privacyProtection: 'プライバシー保護',
  privacyProtectionDesc: 'お客様のデータは厳重に保護され、決して外部に漏れることはありません',
  carefulReply: '人間による返信',
  carefulReplyDesc: 'すべてのメールは実際の人間が丁寧に読んで返信します',
  faq: 'よくある質問',
  commonQuestions: 'よくある質問',
  faqSubtitle: 'ここに最もよく聞かれる質問があります',
  faq1Question: 'このプラットフォームの使い方は？',
  faq1Answer: '無料アカウントを登録して、ペットのプロフィールを作成するだけです。プロセス全体は非常にシンプルで、数分しかかかりません。',
  faq2Question: 'データは安全ですか？',
  faq2Answer: '絶対に安全です。業界標準の暗号化技術を使用してデータを保護し、個人情報を第三者と共有することは決してありません。',
  faq3Question: '何人と共有できますか？',
  faq3Answer: 'ペットのプロフィールを任意の数のケアギバーや家族と共有できます。各共有リンクは独立しており、安全です。',
  faq4Question: 'パスワードを忘れた場合はどうすればいいですか？',
  faq4Answer: 'ログインページで「パスワードを忘れた」をクリックし、登録したメールアドレスを入力すると、パスワードリセットリンクが送信されます。',
  moreQuestions: '他に質問がありますか？',
  moreQuestionsDesc: '他にご質問がある場合は、いつでもメールでお問い合わせください',
  sendEmailNow: '今すぐメールを送信',

  // SettingsPage
  settingsTitle: '設定',
  settingsDescription: 'アカウント設定と環境設定を管理',
  accountSettings: 'アカウント設定',
  changePassword: 'パスワードを変更',
  accountInfoSubtitle: '個人情報を更新',
  firstName: '名',
  lastName: '姓',
  email: 'メール',
  emailPlaceholder: 'あなたのメール',
  emailCannotBeChanged: 'メールは変更できません',
  phoneNumber: '電話番号',
  phonePlaceholder: 'あなたの電話番号',
  saveChanges: '変更を保存',
  saving: '保存中...',
  changePasswordSubtitle: 'アカウントパスワードを更新',
  currentPassword: '現在のパスワード',
  enterCurrentPassword: '現在のパスワードを入力',
  newPassword: '新しいパスワード',
  enterNewPassword: '新しいパスワードを入力',
  confirmPassword: 'パスワードを確認',
  confirmNewPassword: '新しいパスワードを再入力',
  updatePasswordButton: 'パスワードを更新',
  updating: '更新中...',
  passwordRequirements: 'パスワード要件',
  passwordMinLength: '少なくとも6文字',
  passwordMixCase: '大文字を含む',
  passwordMismatch: 'パスワードが一致しません',
  passwordsMatch: 'パスワードが一致します',
  accountUpdated: 'アカウント情報が更新されました',
  passwordUpdated: 'パスワードが更新されました',
  fetchError: 'データの読み込みに失敗しました',
  updateError: '更新に失敗しました',
  userNotFound: 'ユーザーが見つかりません',
  currentPasswordRequired: '現在のパスワードを入力してください',
  currentPasswordIncorrect: '現在のパスワードが正しくありません',
  passwordTooShort: 'パスワードが短すぎます',
  samePasswordError: '新しいパスワードは古いパスワードと同じにできません',
  rateLimitError: '試行回数が多すぎます。後でもう一度お試しください',
  networkError: 'ネットワークエラー。接続を確認してください',
  logout: 'ログアウト',
  logoutToLogin: 'ログアウトしてログインページに戻る',
  loggingOut: 'ログアウト中...',
  redirectingToLogin: 'ログインページにリダイレクト中...',
  refreshingPage: 'ページを更新中...',
  loading: '読み込み中...',

  // PrivacyPage
  privacyPolicyTitle: 'プライバシーポリシー',
  privacyPolicySubtitle: 'あなたのプライバシーを尊重し、個人情報を保護します',
  lastUpdated: '最終更新',
  effectiveDate: '2025年12月20日',
  privacyIntroTitle: '紹介',
  privacyIntro: 'このプライバシーポリシーは、個人情報の収集、使用、保護方法を説明します。',
  dataCollectionTitle: '収集する情報',
  dataCollectionDesc: '次のタイプの情報を収集します：',
  personalInfoTitle: '個人情報',
  personalInfoItem1: '名前とメールアドレス',
  personalInfoItem2: '電話番号（オプション）',
  personalInfoItem3: 'アカウント認証情報',
  petInfoTitle: 'ペット情報',
  petInfoItem1: 'ペット名、品種、年齢',
  petInfoItem2: '健康記録とワクチン情報',
  petInfoItem3: 'ケア指示とノート',
  petInfoItem4: 'ペットの写真',
  technicalDataTitle: '技術データ',
  technicalDataItem1: 'IPアドレスとブラウザ情報',
  technicalDataItem2: '使用パターンと環境設定',
  technicalDataItem3: 'Cookieと類似技術',
  dataUsageTitle: '情報の使用方法',
  dataUsageDesc: '収集した情報を次の目的で使用します：',
  dataUsageItem1: 'サービスの提供と改善',
  dataUsageItem2: 'エクスペリエンスのパーソナライズ',
  dataUsageItem3: '重要な通知と更新の送信',
  dataUsageItem4: 'お問い合わせへの対応',
  dataUsageItem5: 'プラットフォームのセキュリティ維持',
  dataUsageItem6: '法的義務の遵守',
  dataUsageItem7: 'サービス品質の分析と改善',
  dataSecurityTitle: 'データセキュリティ',
  dataSecurityDesc: 'データを保護するために複数のセキュリティ対策を講じています：',
  dataSecurityItem1: '暗號化された送信と保存',
  dataSecurityItem2: '定期的なセキュリティ監査',
  dataSecurityItem3: '厳格なアクセス制御',
  dataSecurityItem4: '従業員トレーニングと機密保持契約',
  dataSecurityItem5: 'タイムリーなセキュリティ更新',
  dataSecurityNote: 'データを保護するよう努めていますが、100%安全なシステムはありません。',
  dataSharingTitle: '情報の共有',
  dataSharingDesc: '個人情報を販売しません。次の場合に情報を共有する場合があります：',
  dataSharingItem1: 'あなたの同意を得た後',
  dataSharingItem2: 'サービスプロバイダー（クラウドストレージなど）と',
  dataSharingItem3: '法的要件を遵守するため',
  dataSharingItem4: '私たちの権利と安全を保護するため',
  yourRightsTitle: 'あなたの権利',
  yourRightsDesc: '個人情報に関して次の権利があります：',
  yourRightsItem1: 'データへのアクセス',
  yourRightsItem2: '不正確なデータの修正',
  yourRightsItem3: 'データの削除',
  yourRightsItem4: 'データ処理の制限',
  yourRightsItem5: 'データの移植性',
  yourRightsItem6: 'データ処理への異議',
  yourRightsNote: 'これらの権利を行使するには、サポートチームにお問い合わせください。',
  dataRetentionTitle: 'データ保持',
  dataRetentionDesc: '次の期間データを保持します：',
  dataRetentionItem1: 'アカウントがアクティブである間',
  dataRetentionItem2: 'サービス提供に必要な期間',
  dataRetentionItem3: '法律または規制で要求される期間',
  dataRetentionItem4: '紛争解決と契約執行のため',
  dataRetentionNote: 'いつでもアカウントとデータを削除できます。',
  cookiesTitle: 'Cookieとトラッキング技術',
  cookiesDesc: 'Cookieと類似技術を次の目的で使用します：',
  cookiesItem1: '環境設定を記憶',
  cookiesItem2: 'ウェブサイトの使用状況を分析',
  cookiesItem3: 'ユーザーエクスペリエンスの改善',
  cookiesNote: 'ブラウザ設定でCookie環境設定を管理できます。',
  childrensPrivacyTitle: '子供のプライバシー',
  childrensPrivacyDesc: '私たちのサービスは13歳未満の子供を対象としていません。子供の個人情報を故意に収集しません。',
  internationalTransfersTitle: '國際データ転送',
  internationalTransfersDesc: 'データはあなたの国/地域外のサーバーに転送される場合があります。適切な保護措置が講じられていることを確認します。',
  policyChangesTitle: 'ポリシーの変更',
  policyChangesDesc: 'このプライバシーポリシーを隨時更新する場合があります。重要な変更については、メールまたはプラットフォーム通知でお知らせします。',
  contactInfoTitle: '連絡先情報',
  contactInfoDesc: 'このプライバシーポリシーについて質問がある場合は、お問い合わせください：',
  contactEmail: 'メール',
  contactEmailValue: 'info@homy.hk',
  viewTerms: '利用規約を表示',

  // TermsPage
  termsOfServiceTitle: '利用規約',
  termsOfServiceSubtitle: 'サービス利用の利用規約',
  termsIntroTitle: '規約の承諾',
  termsIntro: 'サービスを使用することで、これらの規約に同意したことになります。よくお読みください。',
  serviceDescriptionTitle: 'サービスの説明',
  serviceDescriptionDesc: 'ペットケアプラットフォームは次のサービスを提供します：',
  serviceDescriptionItem1: 'ペット情報管理',
  serviceDescriptionItem2: '健康記録追跡',
  serviceDescriptionItem3: 'ケア指示の共有',
  serviceDescriptionItem4: '獣醫情報の保存',
  serviceDescriptionItem5: 'リマインダーと通知',
  userAccountTitle: 'ユーザーアカウント',
  userAccountDesc: 'サービスを使用するには、次のことが必要です：',
  userAccountItem1: 'アカウントを作成し、正確な情報を提供',
  userAccountItem2: 'アカウント認証情報を保護',
  userAccountItem3: 'アカウント下のアクティビティに責任を持つ',
  userAccountItem4: '不正使用を通知',
  userAccountItem5: '18歳以上であるか、親の同意を得ている',
  userAccountNote: 'アカウントのセキュリティを維持する責任があります。',
  userResponsibilitiesTitle: 'ユーザーの責任',
  userResponsibilitiesDesc: 'サービスを使用する際、次のことに同意します：',
  userResponsibilitiesItem1: '正確で最新の情報提供',
  userResponsibilitiesItem2: 'すべての適用法を遵守',
  userResponsibilitiesItem3: '他のユーザーの権利を尊重',
  userResponsibilitiesItem4: 'サービスを悪用または誤用しない',
  userResponsibilitiesItem5: '重要なデータをバックアップ',
  userResponsibilitiesItem6: 'アップロードするコンテンツに責任を持つ',
  prohibitedActivitiesTitle: '禁止行為',
  prohibitedActivitiesDesc: '次のことをしてはいけません：',
  prohibitedActivitiesItem1: '法律または規制に違反',
  prohibitedActivitiesItem2: '他人の権利を侵害',
  prohibitedActivitiesItem3: 'マルウェアやウイルスをアップロード',
  prohibitedActivitiesItem4: '不正アクセスを試みる',
  prohibitedActivitiesItem5: 'サービス運用を妨害',
  prohibitedActivitiesItem6: 'アカウントを販売または譲渡',
  intellectualPropertyTitle: '知的財産',
  intellectualPropertyDesc: 'サービスは知的財産法によって保護されています：',
  intellectualPropertyItem1: 'プラットフォームのすべての権利を所有',
  intellectualPropertyItem2: 'コンテンツの所有權を保持',
  intellectualPropertyItem3: 'コンテンツを使用するライセンスを付与',
  intellectualPropertyItem4: '許可なく商標を使用しない',
  intellectualPropertyNote: 'アップロードしたコンテンツはあなたのものですが、サービスを提供するためのライセンスを付與します。',
  dataOwnershipTitle: 'データ所有權',
  dataOwnershipDesc: 'データについて：',
  dataOwnershipItem1: 'アップロードしたすべてのデータを所有',
  dataOwnershipItem2: 'いつでもデータをエクスポートまたは削除可能',
  dataOwnershipItem3: 'コンテンツの所有權を主張しない',
  dataOwnershipItem4: 'アカウント削除後、データは永久に削除される',
  serviceAvailabilityTitle: 'サービスの可用性',
  serviceAvailabilityDesc: 'サービスの可用性について：',
  serviceAvailabilityItem1: 'サービスを実行し続けるよう努めますが、100%の稼働時間を保証しません',
  serviceAvailabilityItem2: '計畫的または計畫外のダウンタイムがある場合があります',
  serviceAvailabilityItem3: 'いつでもサービスを変更または中止する場合があります',
  serviceAvailabilityItem4: 'サービス中斷による損失には責任を負いません',
  disclaimerTitle: '免責事項',
  disclaimerDesc: 'サービスは「現状のまま」提供されます：',
  disclaimerItem1: 'エラーのない中斷のないサービスを保証しません',
  disclaimerItem2: '結果の正確性を保証しません',
  disclaimerItem3: '獣醫または醫療アドバイスを提供しません',
  disclaimerItem4: 'ユーザーは専門家に相談する必要があります',
  disclaimerItem5: 'ユーザーの決定には責任を負いません',
  limitationOfLiabilityTitle: '責任の制限',
  limitationOfLiabilityDesc: '法律で許可される最大限の範囲で：',
  limitationOfLiabilityItem1: '間接的な損失には責任を負いません',
  limitationOfLiabilityItem2: '責任は支払った料金に制限されます',
  limitationOfLiabilityItem3: '一部の管轄區域ではこれらの制限が許可されない場合があります',
  terminationTitle: '終了',
  terminationDesc: 'アカウント終了について：',
  terminationItem1: 'いつでもアカウントを閉じることができます',
  terminationItem2: '違反によりアカウントを停止または終了する場合があります',
  terminationItem3: '終了後、データは削除されます',
  terminationItem4: '一部の條項は終了後も有効です',
  changestoTermsTitle: '規約の変更',
  changestoTermsDesc: 'これらの規約を更新する場合があります：',
  changestoTermsItem1: '重要な変更を通知します',
  changestoTermsItem2: '継続使用は新しい規約の受け入れを示します',
  changestoTermsItem3: '同意しない場合は、サービスの使用を停止する必要があります',
  governingLawTitle: '準拠法',
  governingLawDesc: 'これらの規約は次の法律に準拠します：',
  governingLawItem1: '香港法が適用されます',
  governingLawItem2: '紛爭は香港の裁判所で解決されます',
  governingLawItem3: '兩當事者は陪審裁判の權利を放棄します',
  contactForTermsTitle: 'お問い合わせ',
  contactForTermsDesc: 'これらの規約について質問がある場合は、お問い合わせください：',
  contactForTermsEmail: 'info@homy.hk',
  viewPrivacy: 'プライバシーポリシーを表示',
};